import { canonicalHttpCandidateOrigin, DomainError } from "@econ-v1/domain";
export function normalizeHttpsOrigin(value) {
    let url;
    try {
        url = new URL(value);
    }
    catch {
        throw invalidOrigin();
    }
    if (url.protocol !== "https:" ||
        url.username !== "" ||
        url.password !== "" ||
        url.hostname === "") {
        throw invalidOrigin();
    }
    return url.origin;
}
export function canonicalHttpsOrigin(value) {
    try {
        return canonicalHttpCandidateOrigin(value);
    }
    catch {
        throw invalidOrigin();
    }
}
function invalidOrigin() {
    return new DomainError({
        code: "invalid_request",
        message: "HTTP transport candidates must use an exact secure origin",
    });
}
//# sourceMappingURL=http-origin.js.map